const DEFAULT_TITLE = 'LavSan - Сантехника и товары для ванной';
const DEFAULT_DESCRIPTION = 'Интернет-магазин LavSan Store — сантехника, смесители, ванны, унитазы, мебель для ванной. Доставка по Краснодарскому краю.';

const getOrigin = () => {
  if (typeof window !== 'undefined' && window.location?.origin) return window.location.origin;
  return 'https://lav-san.ru';
};

export const toAbsoluteUrl = (path = '/') => {
  try {
    return new URL(path, `${getOrigin()}/`).toString();
  } catch {
    return `${getOrigin()}${path}`;
  }
};

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let node = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!node) {
    node = document.createElement('meta');
    node.setAttribute(attr, key);
    document.head.appendChild(node);
  }
  node.setAttribute('content', content);
};

const removeMeta = (attr, key) => {
  const node = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (node) node.remove();
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let node = document.head.querySelector(`link[rel="${rel}"]`);
  if (!node) {
    node = document.createElement('link');
    node.setAttribute('rel', rel);
    document.head.appendChild(node);
  }
  node.setAttribute('href', href);
};

export const setSeoMeta = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, canonical, og = {} }) => {
  document.title = title;

  upsertMeta('name', 'description', description);
  upsertLink('canonical', canonical || toAbsoluteUrl(window.location.pathname));

  upsertMeta('property', 'og:title', og.title || title);
  upsertMeta('property', 'og:description', og.description || description);
  upsertMeta('property', 'og:type', og.type || 'website');
  upsertMeta('property', 'og:url', og.url || canonical || toAbsoluteUrl(window.location.pathname));
  if (og.image) upsertMeta('property', 'og:image', og.image);
  else removeMeta('property', 'og:image');
};

export const upsertJsonLd = (id, data) => {
  if (!data) return;
  let node = document.head.querySelector(`script[type="application/ld+json"][data-seo-id="${id}"]`);
  if (!node) {
    node = document.createElement('script');
    node.type = 'application/ld+json';
    node.setAttribute('data-seo-id', id);
    document.head.appendChild(node);
  }
  node.textContent = JSON.stringify(data);
};

export const removeJsonLd = (id) => {
  const node = document.head.querySelector(`script[type="application/ld+json"][data-seo-id="${id}"]`);
  if (node) node.remove();
};
